import {Directive, ElementRef, HostListener, Input} from '@angular/core';
import {Subject} from 'rxjs';
import {destroy$} from '../destroyable';
import {DynamicComponentRef} from '../dynamic-component';
import {CommonFlashMessageNotification} from '../flash-message/common-flash-message-notification';
import {ModalService} from '../modal';
import {CopyTooltipBalloonComponent} from './copy-tooltip-balloon.component';

@Directive({
    selector:   '[copyTooltip]',
    exportAs:   'copyTooltip',
    standalone: false
})
export class CopyTooltipDirective {

    @Input()
    public copyTooltip: string;

    @Input()
    public bubbleNotification$?: Subject<CommonFlashMessageNotification>;

    public readonly destroy$ = destroy$();

    protected readonly balloonClass = CopyTooltipBalloonComponent;

    private copyTooltipComponentRef: DynamicComponentRef<CopyTooltipBalloonComponent>;
    private hideTimeoutId: number;

    constructor(
        protected elementRef: ElementRef,
        protected modalService: ModalService
    ) {}

    @HostListener('mouseenter')
    public onMouseEnter(): void {
        if (this.copyTooltip && !this.copyTooltipComponentRef) {
            this.showCopyTooltip();
        }
        this.clearHideTimeout();
    }

    @HostListener('mouseleave')
    public onMouseLeave(): void {
        this.scheduleHideCopyTooltip();
    }

    public hide(): void {
        this.hideCopyTooltip();
    }

    public scheduleHideCopyTooltip(): void {
        this.clearHideTimeout();
        this.hideTimeoutId = window.setTimeout(() => {
            this.hideCopyTooltip();
        }, 50); // 50ms delay to allow mouse to move to tooltip
    }

    public clearHideTimeout(): void {
        if (this.hideTimeoutId) {
            clearTimeout(this.hideTimeoutId);
            this.hideTimeoutId = null;
        }
    }

    private showCopyTooltip(): void {
        if (!this.copyTooltip) {
            return;
        }

        this.copyTooltipComponentRef = this.modalService.open(this.balloonClass, {
            configure:   {
                referenceElementRef:     this.elementRef,
                content:                 this.copyTooltip,
                bubbleNotification$:     this.bubbleNotification$,
                clearHideTimeout:        () => this.clearHideTimeout(),
                scheduleHideCopyTooltip: () => this.scheduleHideCopyTooltip()
            },
            destroyWhen: this.destroy$,
            onDestroy:   () => {
                this.copyTooltipComponentRef = null;
                this.clearHideTimeout();
            }
        });

        this.copyTooltipComponentRef.componentRef.changeDetectorRef.detectChanges();
    }

    private hideCopyTooltip(): void {
        if (this.copyTooltipComponentRef) {
            this.copyTooltipComponentRef.destroy();
            this.copyTooltipComponentRef = null;
        }
        this.clearHideTimeout();
    }

}
